<cm-table-selected-filter *ngIf="isSelectable && showSelectedFilter"></cm-table-selected-filter>
<cm-table-filter *ngFor="let field of filteredColumns$ | async" [field]="field"></cm-table-filter>
<div class="table-meta__search-actions">
	<cm-table-search *ngIf="showSearch"></cm-table-search>
	<div class="table-meta__actions" *ngIf="!(hideExport$ | async)">
		<button
			mat-button
			cm-mini-button
			(click)="exportCSV()"
			[matTooltip]="'Download to CSV' | cmLocalize : 'Core/System.Table.Button.Export'"
			[attr.aria-label]="'Download to CSV' | cmLocalize : 'Core/System.Table.Button.Export'">
			<ats-icon name="download"></ats-icon>
		</button>
	</div>
</div>
